import styled from "styled-components";

export const LottieOverlay = styled.div<{ $blocking: boolean }>(({ theme, $blocking }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: $blocking ? "all" : "none",
    zIndex: 1,
    borderRadius: theme.cornerRadius.medium,
    overflow: "hidden",
}));
